import React from 'react';
import classNames from 'classnames';
import { type GeneralID, ImageType, type SceneData } from '@types';
import Image from '@components/Image';
import { TipWrapper } from '@components/TipWrapper';
import TypeMark from '../SceneList/TypeMark';

interface Props {
  data: SceneData;
  isSelected?: boolean;
  disabled?: boolean;
  onClick: (payload: { id: GeneralID; isSelected: boolean }) => void;
}

function SceneModalItem({
  data,
  isSelected = false,
  disabled = false,
  onClick,
}: Props) {
  const { id, thumbUrl, name, type } = data;
  return (
    <TipWrapper className="mr-10 mt-10" size="sm" text={name}>
      <div
        className={classNames(
          'relative h-80 w-80 flex-shrink-0 rounded border-2 border-transparent focus:outline-none',
          {
            'opacity-50': disabled,
            'cursor-pointer': !disabled,
          }
        )}
        onClick={() => !disabled && onClick({ id, isSelected })}
      >
        <Image
          className={classNames('h-full w-full rounded', {
            'ring-2 ring-orange': isSelected,
          })}
          src={thumbUrl}
          type={ImageType.thumb}
          size={80}
        />
        <div className="absolute bottom-0 left-0 right-0 truncate rounded-b bg-black-black bg-opacity-50 px-2 text-center text-sm text-white">
          {name}
        </div>
        <TypeMark type={type} />
      </div>
    </TipWrapper>
  );
}

export default React.memo(SceneModalItem);
